export default __webpack_public_path__ + "static/media/carcas.b0150fff.jpg";